import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCountries, saveBatchCountries } from '../../api/countries';
import type { Country } from '../../types/Country';
import { t } from '../../i18n/t';

const columnDefs: ColDef<Country>[] = [
  {
    field: 'countryId',
    headerName: t('countries.columns.countryId'),
    width: 130,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<Country>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'countryCode',
    headerName: t('countries.columns.countryCode'),
    flex: 1,
    cellDataType: 'text',
    editable: true,
  },
  {
    field: 'nameEn',
    headerName: t('countries.columns.nameEn'),
    flex: 1,
    cellDataType: 'text',
    editable: true,
  },
  {
    field: 'nameHe',
    headerName: t('countries.columns.nameHe'),
    flex: 1,
    cellDataType: 'text',
    editable: true,
  },
  {
    field: 'continentId',
    headerName: t('countries.columns.continentId'),
    width: 150,
    cellDataType: 'number',
    editable: true,
  },
  {
    field: 'countryId4Rashut',
    headerName: t('countries.columns.countryId4Rashut'),
    width: 150,
    cellDataType: 'number',
    editable: true,
  },
  {
    field: 'bloombergName',
    headerName: t('countries.columns.bloombergName'),
    width: 150,
    cellDataType: 'text',
    editable: true,
  },
  {
    field: 'tax',
    headerName: t('countries.columns.tax'),
    width: 150,
    cellDataType: 'number',
    editable: true,
  },
];

const newRowDefaults = (): Partial<Country> => ({
  countryId: 0,
  countryCode: '',
  nameEn: '',
  nameHe: '',
  continentId: null,
  countryId4Rashut: null,
  bloombergName: null,
  tax: null,
});

export function CountriesPage() {
  return (
    <LopCrudPage<Country>
      resourceCode="countries"
      titleKey="countries.pageTitle"
      idField="countryId"
      getRows={getCountries}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchCountries(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
